
import VueMultiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

// https://vue-multiselect.js.org/
export default {
  mixins: [VueMultiselect],

  props: {
    // Used to identify the component in events
    id: {
      type: String,
      default: () => {
        return `multiselect-id-${Date.now()}`
      }
    },

    // Equivalent to the multiple attribute on a <select> input
    multiple: {
      type: Boolean,
      default: true
    },

    // String to show when pointing to an option
    selectLabel: {
      type: String,
      default: 'Clique para selecionar'
    },

    // String to show when pointing to an option group
    selectGroupLabel: {
      type: String,
      default: 'Clique para selecionar o grupo'
    },

    // String to show next to selected option
    selectedLabel: {
      type: String,
      default: 'Selecionado'
    },

    // String to show when pointing to an already selected option
    deselectLabel: {
      type: String,
      default: 'Clique para remover'
    },

    // String to show when pointing to an already selected option group
    deselectGroupLabel: {
      type: String,
      default: 'Clique para remover o grupo'
    },

    // Equivalent to the placeholder attribute on a input
    placeholder: {
      type: String,
      default: 'Selecione'
    },

    // String to show when highlighting a potential tag
    tagPlaceholder: {
      type: String,
      default: 'Clique para adicionar uma tag'
    },

    // Multiselect required property
    required: {
      type: Boolean,
      default: false
    },

    // Enable/disable highlighting of the pointed value
    showPointer: {
      type: Boolean,
      default: false
    },

    // Add / removes search input.
    searchable: {
      type: Boolean,
      default: true
    },

    // Array of keyboard key aliases to block when selecting
    blockKeys: {
      type: Array,
      default: () => {
        return ['Delete']
      }
    },

    // 	Label from option Object, that will be visible in the dropdown
    label: {
      type: String,
      default: 'label'
    },

    // 	Used to compare objects. Only use if options are objects
    trackBy: {
      type: String,
      default: 'value'
    },

    // By default new tags will appear above the search results. Changing to 'bottom' will revert this behaviour and will proritize the search results
    tagPosition: {
      type: String,
      default: 'bottom'
    }
  },

  watch: {
    value: {
      handler() {
        this.handleRequired()
      }
    },

    required: {
      handler() {
        this.handleRequired()
      }
    }
  },

  mounted() {
    this.handleRequired()
  },

  methods: {
    handleRequired() {
      const element = document.getElementById(this.id)

      if (this.required && !this.value) {
        element.setAttribute('required', true)
      } else {
        element.removeAttribute('required')
      }
    }
  }
}
